import { render, staticRenderFns } from "./vendorView.vue?vue&type=template&id=d135d962&scoped=true"
import script from "./vendorView.vue?vue&type=script&lang=js"
export * from "./vendorView.vue?vue&type=script&lang=js"
import style0 from "./vendorView.vue?vue&type=style&index=0&id=d135d962&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d135d962",
  null
  
)

export default component.exports